<script setup lang="ts">
import { computed } from 'vue';
import {
    formatMyAddressRowBodyForDisplay,
    getMyAddressAlias,
    type MyAddressDisplayContext,
} from '../utils/contactMyLocationFields';

const props = withDefaults(
    defineProps<{
        address?: Record<string, unknown> | null;
        countryOpts?: MyAddressDisplayContext['countryOpts'];
        stateOpts?: MyAddressDisplayContext['stateOpts'];
        cityOpts?: MyAddressDisplayContext['cityOpts'];
        postcodeOpts?: MyAddressDisplayContext['postcodeOpts'];
    }>(),
    {
        address: null,
        countryOpts: () => [],
        stateOpts: () => [],
        cityOpts: () => [],
        postcodeOpts: () => [],
    },
);

const aliasLabel = computed(() => getMyAddressAlias(props.address));

const bodyText = computed(() => {
    const text = formatMyAddressRowBodyForDisplay(props.address, {
        countryOpts: props.countryOpts,
        stateOpts: props.stateOpts,
        cityOpts: props.cityOpts,
        postcodeOpts: props.postcodeOpts,
    });
    return text || '-';
});
</script>

<template>
    <div class="d-flex align-center flex-wrap ga-2 flex-grow-1 my-branch-address-display-line">
        <v-chip
            v-if="aliasLabel"
            size="x-small"
            variant="tonal"
            color="primary"
            class="my-branch-address-alias-chip flex-shrink-0 font-weight-medium"
            label
        >
            {{ aliasLabel }}
        </v-chip>
        <span class="flex-grow-1 text-wrap">{{ bodyText }}</span>
        <slot />
    </div>
</template>

<style scoped>
.my-branch-address-alias-chip {
    height: 22px !important;
    font-size: 0.7rem !important;
    letter-spacing: 0.02em;
}
</style>
